import React, { Component } from 'react'; 
import { Table, Pagination, FormControl, InputGroup, Dropdown, DropdownButton} from 'react-bootstrap';
import _ from 'lodash';

function searchingFor(term, eventKey, subKey){ 
	return function(x){    
    if(_.isArray(x[eventKey])){
      let a = x[eventKey];
      let gg =[]
      _.map(a, (obj) =>{
        if(subKey !== null){
          //gg.push(obj[subKey].toLowerCase().includes(term.toLowerCase()))
          gg.push(_.includes(obj[subKey].toLowerCase(), term.toLowerCase()))
        } else {
          gg.push(_.includes(obj.toLowerCase(), term.toLowerCase()) )
        }
      })
      return _.includes(gg, true) || !term
    } else {
      return _.includes(x[eventKey].toLowerCase() , term.toLowerCase()) || !term;
    }
	}
}
export default class Inventory extends Component { 
  constructor(props){
		super(props)
		this.state={
      activePage: 1,
      term:'',
      eventKey:"region",
      subKey:''
		}
  }
  componentDidMount(){
    this.props.action.actioninventory()
  }
  componentWillMount(){  
    if(!_.isEmpty(this.props.inventory)){
        this.createTemplate(this.props.inventory)
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps){
    if(!_.isEqual(nextProps.action.showModalLogin, this.props.action.showModalLogin) && nextProps.action.showModalLogin === false){     
      this.props.action.actioninventory()
    }   
    if(!_.isEqual(this.props.inventory, nextProps.inventory)){
      this.createTemplate(nextProps.inventory)
    }
  } 

  createTemplate = (data) =>{
    let payload=[]
    _.map(data, (val) =>{      
      _.map(val.centers, (tt) => {
          _.map(tt.clients, (gg) =>{
            let process =[]
            process.push(...gg.processes)  
            // let x =_.find(payload, {'inventoryClientName':gg.inventoryClientName, "region": val.inventoryRegionName})            
              // if(!_.isEmpty(x)){
              //    x.center.push(tt.inventoryCenterName)
              //    process = _.uniqBy(process, 'inventoryProcessId')
              //    x.processes= process
              // } else {
                process = _.uniqBy(process, 'inventoryProcessId')
                payload.push({'inventoryClientName':gg.inventoryClientName,
                processes:process,'center':[tt.inventoryCenterName], 'region':val.inventoryRegionName})
             // }
          })
      }) 
    })
    this.setState({payload:payload})   
  }
  handleSelectPagination = (eventKey) => {
    this.setState({
      activePage: eventKey,
    });
	}
	handleSelectPaginationPrev = () => {
		const {activePage} = this.state;
		this.setState({
      activePage: activePage-1,
    });
	}
	handleSelectPaginationNext = () => {
		const {activePage} = this.state;
		this.setState({
      activePage: activePage+1,
    });
  }	
  handleChange = (e) => {
		this.setState({term:e.target.value})	
  }
  searchFilter =(e, sub) =>{
    this.setState({eventKey:e, subKey:sub})
    if(!_.isEqual(this.state.eventKey, e)){
      this.setState({term:''})
    }
  }
  
  render(){
    const{payload, term, eventKey, subKey, activePage} = this.state;
    const Per_Page=50;    
    let totalPages = 1
    if(!_.isEmpty(payload)) {
     totalPages = Math.ceil(payload.length/Per_Page)
    }
		const startOffset = (this.state.activePage-1) * Per_Page;
		let startCount = 0;
		let items = [];
		for (let number = 1; number <= totalPages; number++) {
			items.push(
				<Pagination.Item key={number} active={number === activePage} onClick={()=>this.handleSelectPagination(number)}>
					{number}
				</Pagination.Item>				
			);
		}
    return(<div>
        <span className='alignRight'>
				<InputGroup>
					<InputGroup.Prepend>
						<InputGroup.Text id="basic-addon1"><i class="fas fa-search"></i></InputGroup.Text>
					</InputGroup.Prepend>
					<FormControl
						placeholder="Search"
						aria-label="Search"
						aria-describedby="basic-addon1"
						onChange={(e) => this.handleChange(e)}
						value={term}
						/>
            <DropdownButton
						 as={InputGroup.Append}
             alignRight
             variant="outline-secondary"
             title=""           
             id="dropdown-menu-align-right"
						>
						<Dropdown.Item 	onSelect={(eventKey) =>this.searchFilter(eventKey, '')} eventKey="region" active={eventKey === "region"}  ><b>REGION</b></Dropdown.Item>
            <Dropdown.Item 	onSelect={(eventKey) =>this.searchFilter(eventKey, null)} eventKey="center" active={eventKey === "center"}  ><b>CENTER</b></Dropdown.Item>
            <Dropdown.Item 	onSelect={(eventKey) =>this.searchFilter(eventKey, '')} eventKey="inventoryClientName" active={eventKey === "inventoryClientName"}  ><b>CLIENT</b></Dropdown.Item>
            <Dropdown.Item 	onSelect={(eventKey) =>this.searchFilter(eventKey, 'inventoryProcessName')} eventKey="processes" active={eventKey === "processes"}  ><b>PROCESS</b></Dropdown.Item>
            </DropdownButton>
				</InputGroup>
				</span>
       <Table responsive>
        <thead>
        <th>REGION</th>
        <th>CENTER</th>
        <th>CLIENT</th>
        <th style={{width:'50%'}}>PROCESS</th>
        </thead>
        <tbody>
        {(!_.isEmpty(payload)) ?
          _.map(payload.filter(searchingFor(term, eventKey, subKey)), (gg, i) =>{        
          	if(i >= startOffset & startCount < Per_Page){
              startCount++;
            return(
              <tr>
                <td>{gg.region}</td>
                <td>{_.map(gg.center, (tt) => { return(<span>{tt}<br/></span>)}) }</td>
                <td>{gg.inventoryClientName}</td>
                <td>{_.map(gg.processes, (tt, index) => { 
                  return((index ? ', ' : '') + tt.inventoryProcessName )}) }</td>
              </tr>
            )
            }              
          })  
          : <tr><td colSpan={"4"}>No Record Found</td></tr>    
        }          
        </tbody>
      </Table>
      <Pagination>
				<Pagination.First  disabled={activePage === 1} onClick={()=>this.handleSelectPagination(1)} />
				<Pagination.Prev   disabled={activePage === 1} onClick={this.handleSelectPaginationPrev} />
          {items[activePage-1]}
          {items[activePage] ? items[activePage] : (activePage !== 1) ? items[0] : null}
          {items[activePage+1]}
				<Pagination.Next disabled={activePage === totalPages} onClick={this.handleSelectPaginationNext}/>
				<Pagination.Last disabled={activePage === totalPages} onClick={()=>this.handleSelectPagination(totalPages)}/>			
			</Pagination>
    </div>)
  }

}